import { __awaiter } from "tslib";
import gql from 'graphql-tag';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { useEffect, useState } from 'react';
import { clearLocalToken, getLocalToken, setLocalToken, setLocalOrg, clearLocalOrg } from '../utils/sessionStorage';
import { createContainer } from 'unstated-next';
import { useLocation } from 'react-router-dom';
const loginOverlayMutation = gql `
  mutation loginOverlay($key: String!) {
    loginOverlay(key: $key) {
      accessToken
      organizationId
    }
  }
`;
const verifyToken = gql `
  query verifyOverlayToken($accessToken: String!) {
    verifyToken(accessToken: $accessToken) {
      valid
    }
  }
`;
const useAuth = () => {
    const location = useLocation();
    const key = location.pathname.split('/')[1];
    const [status, setStatus] = useState('idle');
    const [verifyQuery, { data: verifyData, error: verifyingError, loading: verifying, called: verifyCalled }] = useLazyQuery(verifyToken);
    const [loginMut, { data: loginData, error: loginError, loading: loggingIn, called: loginCalled }] = useMutation(loginOverlayMutation);
    const login = () => __awaiter(void 0, void 0, void 0, function* () {
        yield loginMut({
            variables: {
                key
            }
        });
    });
    const verify = () => __awaiter(void 0, void 0, void 0, function* () {
        if (key) {
            const accessToken = getLocalToken(key);
            if (accessToken) {
                return verifyQuery({ variables: { accessToken } });
            }
            login();
        }
    });
    useEffect(() => {
        if (key && (loginData === null || loginData === void 0 ? void 0 : loginData.loginOverlay)) {
            setLocalToken(key, loginData.loginOverlay.accessToken);
            setLocalOrg(key, loginData.loginOverlay.organizationId);
        }
    }, [loginData, key]);
    useEffect(() => {
        verify();
    }, []);
    useEffect(() => {
        if (verifyingError || (verifyData && !(verifyData === null || verifyData === void 0 ? void 0 : verifyData.verifyToken.valid))) {
            clearLocalToken(key);
            clearLocalOrg(key);
            login();
        }
    }, [verifyingError, verifyData]);
    useEffect(() => {
        if (!verifyCalled && !loginCalled) {
            return;
        }
        if (verifying) {
            setStatus('verifying');
        }
        else if (loggingIn) {
            setStatus('loggingIn');
        }
        else {
            let token;
            if (key) {
                token = getLocalToken(key);
            }
            token && setStatus('loggedIn');
        }
    }, [verifying, loggingIn, loginData, verifyData]);
    // Debug
    // useMemo(() => console.log(status), [status]);
    return {
        status,
        loginError
    };
};
export const Auth = createContainer(useAuth);
//# sourceMappingURL=authContainer.js.map